module.exports = "/build/admin/images/apple-touch-icon-114x114.526d26b9.png";